import { eManulSortLayerDrawOrder } from "../../../Game";
import { TIMER } from "../../Gameplay";
import { ePhysicsObjects } from "../../Stadium/Stadium";
import { TargetManager } from "../TargetManager";
import { TargetType } from "../TargetType";
import { eTargetState, TargetBase } from "./Target";



export class BonusTarget extends TargetBase {
    private static readonly RADIUS = 0.35;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(mng: TargetManager, type: TargetType) {
        super(mng, type);

        // Detekce kolize
        this._entity.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.cylinder,
            radius: BonusTarget.RADIUS,
            height: 0.2,
            axis: 1
        });
        this._entity.collision.on("triggerenter", this.handleTriggerEnter, this);

        // Velikost terce
        this._width = this._height = BonusTarget.RADIUS * 2;

        // Nasobeni skore
        this._scoreMultiplier = 1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state != eTargetState.hidden) {
            super.update();

            // Rotace
            this._container.rotate(0, 0, this._state != eTargetState.hit ? 1 : 5);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected init(): void {
        // Poradi vykreslovani terce
        this._entity.model.meshInstances[0].drawOrder = eManulSortLayerDrawOrder.target + this._id;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateScale(): void {
        this._entity.collision.radius = BonusTarget.RADIUS * this._scale;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateOpacity(): void {
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTriggerEnter(other: pc.Entity): void {
        if (other.name != ePhysicsObjects.ball || this._state != eTargetState.idle)
            return;

        let targetPos = this._container.getPosition();
        let ballPos = other.getPosition();
        let hitEntry = this.calculateHit(new pc.Vec2(targetPos.x, targetPos.y), new pc.Vec2(ballPos.x, ballPos.y));

        if (!hitEntry)
            return;

        // Animace zmizeni
        this.startHitAnim();

        // Predat udalost "triggerenter" mici
        other.collision.fire("triggerenter", this._entity);
    }
}